





















import { Component, Vue, Watch } from "vue-property-decorator";
import Breadcrumb from "@/components/breadcrumb.vue";
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
import { Mutation, State, Action } from "vuex-class";
import AccountDialog from "@/views/user/account-dialog.vue";
import userService from '@/service/userService'
import { AppUtil } from '@/utils/app.util'
import { LocalStorageService, SessionStorageService, CookieService } from "@/service/storageService";
import { Constants } from "@/const/Constants"
@Component({
  components: { Breadcrumb, Header, Footer, AccountDialog }
})
export default class App extends Vue {
  @Mutation private SET_ROUTE_NAME: any;
  @State("userInfo") userInfo!: any;
  @Action('SET_USER_INFO_ASYN') setUserInfo!: (data: any) => void
  @Watch("$route", { deep: true })
  private routeChange(to: any, from: any) {
    this.SET_ROUTE_NAME(to.name);
  }

  private created() {
    const userInfo = userService.getLoginedUser()
    if (AppUtil.isNotEmpty(userInfo) && AppUtil.isNotEmpty(userInfo.nick)) {
      this.setUserInfo(userInfo)
    } else {
      this.getVisitorToken()
    }
  }
  // 无token获取游客token
  getVisitorToken() {
    userService.initVisitorsToken(userService.appInfoAtiak).then((data: any) => {
      if (data && data.success) {
        LocalStorageService.remove(Constants.Storage_Local.Login_Time);
        userService.removeCookieUser();
        SessionStorageService.remove(Constants.Storage_Session.Ext_Prompt_Flag);
        CookieService.remove(Constants.Cookie.Auth_Info,);
      }
    })
  }

}
